import { useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { sendQuotePdfEmail } from "@/lib/pdfLazy";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { toast } from "sonner";

const METHODS = [["cb", "Carte bancaire"], ["cheque", "Chèque"], ["virement", "Virement"], ["financement", "Financement"]];

// Admin: fix the seller and deposit method of a signed order without a new signature
export const AdminCorrectDialog = ({ quote, onClose, onSaved }) => {
  const [resellers, setResellers] = useState([]);
  const [seller, setSeller] = useState("");
  const [methods, setMethods] = useState([]);
  const [send, setSend] = useState(true);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!quote) return;
    setSeller(quote.reseller_id || ""); setMethods(quote.deposit_methods || []); setSend(true);
    api.get("/act-as/resellers").then(({ data }) => setResellers(data)).catch(() => setResellers([]));
  }, [quote]);
  if (!quote) return null;
  const list = resellers.some((r) => r.id === quote.reseller_id) ? resellers : [{ id: quote.reseller_id, name: quote.reseller_name }, ...resellers];
  const toggle = (m) => setMethods((ms) => (ms.includes(m) ? ms.filter((x) => x !== m) : [...ms, m]));
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/quotes/${quote.id}/admin-correct`, { reseller_id: seller, deposit_methods: methods });
      if (!data.changed) { toast.info("Aucune modification"); onClose(); return; }
      if (send) {
        await sendQuotePdfEmail(quote.id, "", false, null, { onlyReseller: true });
        toast.success("Commande corrigée et envoyée au revendeur (copie contact@fautras.com)");
      } else toast.success("Commande corrigée");
      onSaved();
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Correction impossible"); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="admin-correct-dialog">
        <DialogHeader>
          <DialogTitle>Corriger la commande {quote.quote_number}</DialogTitle>
          <DialogDescription>Sans nouvelle signature du client. La correction est notée dans l'historique.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4 text-sm">
          <div><Label>Revendeur</Label>
            <Select value={seller} onValueChange={setSeller}>
              <SelectTrigger className="mt-1" data-testid="ac-reseller"><SelectValue /></SelectTrigger>
              <SelectContent>{list.map((r) => <SelectItem key={r.id} value={r.id} data-testid={`ac-reseller-${r.id}`}>{r.name}{r.company ? ` — ${r.company}` : ""}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <div><Label>Acompte payé par</Label>
            <div className="flex flex-wrap gap-4 mt-2">
              {METHODS.map(([k, l]) => (
                <label key={k} className="flex items-center gap-1.5 cursor-pointer"><Checkbox checked={methods.includes(k)} onCheckedChange={() => toggle(k)} data-testid={`ac-method-${k}`} />{l}</label>
              ))}
            </div>
          </div>
          <label className="flex items-center gap-2 cursor-pointer"><Checkbox checked={send} onCheckedChange={(v) => setSend(!!v)} data-testid="ac-send" />Envoyer la commande corrigée au revendeur (copie contact@fautras.com)</label>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Annuler</Button>
          <Button onClick={save} disabled={busy || !seller} data-testid="ac-save">Enregistrer</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
